import { required, requiredIf } from "vuelidate/lib/validators";

const step6 = [
  "form.q_6_1",
  "form.q_6_2",
  "form.q_6_2a",
  "form.accommodations"
];

const require62 = function(m) {
  return this.form.q_6_2 === true;
};

const require62a = function(m) {
  return this.form.q_6_2a === false;
};

const step6Validations = {
  q_6_1: { required },
  q_6_2: { required },
  q_6_2a: { required: requiredIf(require62) },
  accommodations: {
    $each: {
      name: { required: requiredIf(require62a) },
      city: { required: requiredIf(require62a) },
      typeStars: { require: requiredIf(require62a) }
    }
  }
};

export { step6Validations, step6 };
